module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("eventStatisticsView.topParticipants", [_vm.store.selectedEvent.name, _vm.numTop])))]), _vm._v(" "), _c('kk-event-participant-top-list', {
    attrs: {
      "event": _vm.store.selectedEvent,
      "num-top": _vm.numTop
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76b62860","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/EventStatisticsView.vue
// module id = 125
// module chunks = 0